import React from 'react';
import { Link } from 'react-router-dom'

class VideoGames extends React.Component{
    render(){
        return (
            <React.Fragment>
              <div className="Page">
                 <div className="Apps">
                     
                 <Link to="/RunOrDie" className="Link Application image-6">
                 </Link>
                        
                        
                        
                 </div>
             </div>
          
            </React.Fragment>
        ); 
    }
}

export default VideoGames;